export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_ENDPOINTS = {
  SUBMIT_ENQUIRY: "/submit",
  SEND_EMAIL_OTP: "/send-otp",
  VERIFY_EMAIL_OTP: "/verify-otp"
};

export const ENROLL_BTN = "Enroll Now";
export const QUOTATION_BTN = "Get Free Consultation";

export const VALIDATION_MESSAGE = {
    FIRST_NAME: {
        REQUIRED: "First Name is required",
        INVALID: "Enter a valid name"
    },
    LAST_NAME: {
        REQUIRED: "Last Name is required",
        INVALID: "Enter a valid name"
    },
    EMAIL: {
        REQUIRED: "Email id is required",
        INVALID: "Enter a valid Email"
    },
    MOBILE: {
        REQUIRED: "Mobile No. is required",
        INVALID: "Enter a valid Mobile No."
    },
    BUSSINESS: {
        REQUIRED: "Bussiness Name is required",
        INVALID: "Enter a valid Bussiness Name"
    },
    WEBSITE: {
        REQUIRED: "Please Select value from dropdown",    
        INVALID: "Enter a valid Website URL"
    },
    POSTAL_CODE: {
        REQUIRED: "Postal/Zip Code is required",    
        INVALID: "Enter a valid Postal/Zip Code"
    },
    DESCRIPTION: {
        MIN_LENGTH: "Description must be at least 10 characters",    
        MAX_LENGTH: "Description should not be max 200 characters"
    }
}